module.exports = __webpack_public_path__ + "static/media/product-analytics.0dccbd2d.svg";